export default "__VITE_ASSET__234d7113__"